import React from 'react';
import { Instagram, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-charcoal text-brand-cream py-16 border-t-4 border-brand-gold" data-id="element-18">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-19">
        <div className="rounded-2xl mb-8 overflow-hidden" data-id="element-20">
          <img src="https://cdn.magicpatterns.com/uploads/qNApjUYyj3sNdkKo87Fe64/Logo_3.png" alt="Avril Balbis Logo" className="h-16 w-auto object-contain" data-id="element-21" />
        </div>

        <h3 className="text-2xl font-serif mb-2" data-id="element-22">Avril Balbis</h3>
        <p className="text-brand-cream/70 tracking-widest uppercase text-sm mb-8" data-id="element-23">
          Manicura y Formación
        </p>

        <div className="flex flex-col md:flex-row gap-8 md:gap-12 mb-12" data-id="element-24">
          <div className="flex items-center justify-center gap-2 text-brand-cream/80 hover:text-brand-gold transition-colors" data-id="element-25">
            <MapPin size={18} data-id="element-26" />
            <span data-id="element-27">18 de Julio 1358, Paysandú, Uruguay</span>
          </div>
          <a href="#" className="flex items-center justify-center gap-2 text-brand-cream/80 hover:text-brand-gold transition-colors" data-id="element-28">
            <Instagram size={18} data-id="element-29" />
            <span data-id="element-30">@avrilbalbis.nails</span>
          </a>
        </div>

        <div className="w-full max-w-md h-px bg-brand-cream/10 mb-8" data-id="element-31"></div>

        <p className="text-xs text-brand-cream/40" data-id="element-32">
          © {new Date().getFullYear()} Avril Balbis. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}